// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_L3IY0","title":"index_title_3TsCp","time":"index_time_AZP76","content":"index_content_1NtFM"};